module.exports = __webpack_public_path__ + "static/media/OkkoLogo.8cba2ce2.jpg";